.regretIndividualButton {
  padding: 0.5rem 1rem;
  background-color: var(--blue-100);
  border: 1px solid var(--blue-700);
  border-radius: 4px;
}
